/**
 * Mensagens padronizadas de UX para toda a aplicação
 * Centraliza textos para manter consistência e facilitar tradução futura
 */

export const ux = {
  // Validação de campos
  requiredPet: "Selecione um pet para continuar.",
  requiredDate: "Escolha uma data válida.",
  requiredHour: "Selecione um horário disponível.",
  requiredRange: "Selecione data de entrada e saída.",
  requiredDuration: "Informe a duração do serviço.",
  invalidRange: "A data de saída deve ser posterior à entrada.",
  pastDate: "A data selecionada não pode ser no passado.",
  
  // Estados de carregamento
  loadingHours: "Carregando horários disponíveis...",
  loadingPrice: "Calculando valor final...",
  loadingData: "Carregando dados...",
  processing: "Processando...",
  
  // Resultados
  noHours: "Nenhum horário disponível para esta data.",
  noResults: "Nenhum resultado encontrado.",
  priceReady: "Valor atualizado!",
  
  // Seleção de datas
  selectDatesFirst: "Escolha as datas antes de continuar.",
  selectDateFirst: "Escolha uma data primeiro.",
  selectCheckIn: "Selecione a data de entrada (check-in).",
  selectCheckOut: "Agora selecione a data de saída (check-out).",
  datesSelected: "Datas selecionadas!",
  
  // Confirmação
  confirmBooking: "Tudo certo! Clique em confirmar para continuar.",
  almostThere: "Quase lá! Complete os campos obrigatórios.",
  invalidBooking: "Ainda faltam informações obrigatórias.",
  readyToBook: "Pronto para reservar!",
  
  // Hospedagem
  hostingHint: "Selecione check-in e check-out para ver o valor.",
  hostingRangeHint: "Clique na data de entrada e depois na de saída.",
  
  // Daycare/Walking
  hourlyHint: "Escolha data, horário e duração.",
  walkingHint: "Selecione quando deseja o passeio.",
  daycareHint: "Informe data, horário e tempo de permanência.",
  
  // Táxi Dog
  taxiHint: "Informe os endereços para calcular a tarifa.",
  taxiCalculating: "Calculando rota e tarifa...",
  taxiReady: "Tarifa calculada! Confira os detalhes.",
  taxiMissingAddresses: "Preencha origem e destino para calcular.",
  
  // Datas indisponíveis
  unavailableDates: "O período contém datas indisponíveis.",
  dateBlocked: "Esta data está bloqueada.",
  dateBooked: "Esta data já está reservada.",
  
  // Ações
  tryAgain: "Tente novamente.",
  contactSupport: "Entre em contato com o suporte se o problema persistir.",
  
  // Sucesso
  bookingCreated: "Reserva criada com sucesso!",
  bookingCancelled: "Reserva cancelada.",
  profileUpdated: "Perfil atualizado!",
  photoUploaded: "Foto enviada!",
  documentSent: "Documento enviado para análise.",
  
  // Erros genéricos
  genericError: "Ocorreu um erro. Tente novamente.",
  networkError: "Falha na conexão. Verifique sua internet.",
  unexpectedError: "Erro inesperado. Tente novamente.",
  
  // Pagamento
  paymentProcessing: "Processando pagamento...",
  paymentSuccess: "Pagamento aprovado!",
  paymentError: "Erro no pagamento. Verifique os dados.",
  
  // Reviews
  reviewSubmitted: "Avaliação enviada!",
  reviewRequired: "Preencha todos os campos da avaliação.",
};

/**
 * Retorna mensagem de hint baseada no tipo de serviço e estado atual
 */
export function getBookingHint(serviceType, state) {
  const { hasDate, hasRange, hasHour, hasDuration, hasPet, hasAddresses, hasDistance } = state;
  
  if (!hasPet) return ux.requiredPet;
  
  switch (serviceType) {
    case 'hosting':
      if (!hasRange) return ux.hostingRangeHint;
      return ux.confirmBooking;
      
    case 'daycare':
      if (!hasDate) return ux.selectDateFirst;
      if (!hasHour) return ux.requiredHour;
      if (!hasDuration) return ux.requiredDuration;
      return ux.confirmBooking;
      
    case 'walking':
      if (!hasDate) return ux.selectDateFirst;
      if (!hasHour) return ux.requiredHour;
      if (!hasDuration) return ux.requiredDuration;
      return ux.confirmBooking;
      
    case 'taxi_dog':
      if (!hasDate) return ux.selectDateFirst;
      if (!hasAddresses) return ux.taxiMissingAddresses;
      if (!hasDistance) return ux.taxiHint;
      return ux.confirmBooking;
      
    case 'partner':
    case 'others':
      if (!hasDate) return ux.selectDateFirst;
      if (!hasHour) return ux.requiredHour;
      return ux.confirmBooking;
      
    default:
      return ux.almostThere;
  }
}

export default ux;
